import { connect, } from 'react-redux';

import ValidPanel from '../components/ValidPanel';
import {
  onExpertReviewsAccordionClick,
  onExpertRatingsAccordionClick,
  onConsumerReviewsAccordionClick,
  onConsumerRatingsAccordionClick,
  onAwardsAccordionClick,
} from '../../sew-core/actions/index';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch,) => ({
  onExpertReviewsAccordionClick: (isOpen,) => dispatch(onExpertReviewsAccordionClick(isOpen,),),
  onExpertRatingsAccordionClick: (isOpen,) => dispatch(onExpertRatingsAccordionClick(isOpen,),),
  onConsumerReviewsAccordionClick: (isOpen,) => dispatch(onConsumerReviewsAccordionClick(isOpen,),),
  onConsumerRatingsAccordionClick: (isOpen,) => dispatch(onConsumerRatingsAccordionClick(isOpen,),),
  onAwardsAccordionClick: (isOpen,) => dispatch(onAwardsAccordionClick(isOpen,),),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ValidPanel,);
